"use strict";
var typed_factory_1 = require('./src/typed.factory');
exports.makeTypedFactory = typed_factory_1.makeTypedFactory;
exports.recordify = typed_factory_1.recordify;
